import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import css from '@emotion/css';
import withNudgeLogic from '../hoc/WithNudgeLogic';
import { hasNewTilBridge, printSubsDeeplink, setupWebViewJavascriptBridge, unifiedOpenDeepLinkUrl } from 'helpers/frmapp/frmAppLink';
import { newPlanpageMetaData, redirectToNewPlanpage, sendDataToGAWithGRX } from 'components/ToiSubscription/utils/redirectionToPlanPage';
import { collectEventfireGa4, getGa4PageViewSet, isIOS } from 'utils/common';
import { clearAmpParams, generateOneLinkURL, getAmpRedirectionParams, getEncTicket, getPrcCookieValue } from 'utils/primeUtil';
import Cookie from 'utils/cookies';
import { loginEventEmitter } from 'components/Login/Login';
import EuBlockerScreen from './EuBlockerScreen';
import BlockerErrorScreen from './BlockerErrorScreen';
import { Container, Title, SubTitle, List, ListItems, ContainerInner, ParaTag, Button, LinkButton, SignInBtn } from '../StoryBlockerNew/StoryBlockerNew.style';
import { NEW_PLANPAGE_URL } from 'constants/index';
import { LOADING_STATE } from 'components/Login/redux';

interface IStoryBlockerV3Props {
    nudgeText: { [key: string]: any };
    isWapView: boolean;
    loginComponent: React.ReactElement;
    userData: { [key: string]: any };
    storyTitle: string;
    msid: string;
    isToiPlusAllowReadOnly: boolean;
    viewType: string;
    isAppView: boolean
    isUpgrade: boolean
    userPrcData: { [key: string]: any }
    transLoading: string
    onRetryToipTransCallback: () => {}
    getLoadingStatus: (status: string) => {}
    shouldShowPopUp: (val: boolean) => {}
    blockerPopUp: boolean
    showFreeTrailBlocker: boolean;
    loading: string;
}

const StoryBlocker = ({
    nudgeText,
    loginComponent,
    isWapView,
    userData,
    msid,
    isToiPlusAllowReadOnly,
    isAppView,
    isUpgrade,
    userPrcData,
    transLoading,
    onRetryToipTransCallback,
    getLoadingStatus,
    shouldShowPopUp,
    blockerPopUp,
    showFreeTrailBlocker,
    loading
}: IStoryBlockerV3Props) => {

    const isLoggedIn = userData && userData.isLoggedIn ? userData.isLoggedIn : undefined;
    const prcValue = userData && userData.prcValue ? userData.prcValue : getPrcCookieValue();

    useEffect(() => {
        if (typeof getLoadingStatus === 'function') {
            getLoadingStatus('DONE');
        }
        if (isWapView) {
            const options = getAmpRedirectionParams();
            if (options.Params?.isampuser) {
                if (options.Params?.toLogin && !isLoggedIn) {
                    loginEventEmitter(undefined, {});
                }
                clearAmpParams();
            }
        }
    }, []);

    const fireGA4 = (obj?: any) => {
        const gaPageViewObj = getGa4PageViewSet() || {};
        const collatedGadata = {
            ...gaPageViewObj,
            'event': obj?.action === 'click' ? 'select_item' : 'view_item_list',
        }
        return collectEventfireGa4(collatedGadata,
            {
                item_name: window.location.href.indexOf('.cms') > -1 ? document.title : window.location.href,
                item_id: msid ? msid : '',
                item_brand: 'product_interventions',
                item_category: 'Nudges',
                item_category2: window.location.href.indexOf('printarticle') > -1 ? 'articleshow' : 'listing',
                item_category3: obj?.item_category3 ? obj?.item_category3 : 'N/A',
                item_category4: obj?.item_category4 ? obj?.item_category4 : 'N/A',
            });
    }

    const redirection = (item: {} | undefined) => {
        if (isLoggedIn || Cookie.get('ssoid') || Cookie.get('ssoId')) {
            getEncTicket(isWapView).then(data => {
                window.location.href = redirectToNewPlanpage(
                    newPlanpageMetaData(item, data),
                );
            });
        } else {
            window.location.href = redirectToNewPlanpage(
                newPlanpageMetaData(item),
            );
        }
    };

    const ctaClickHandler = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent> | React.MouseEvent<HTMLButtonElement, MouseEvent>, item: any) => {
        e.preventDefault();
        let item_category3 = 'digitalView_list_paywall_blocker_cta_main';
        let cta_text = '';
        if ((e.target instanceof HTMLAnchorElement || e.target instanceof HTMLButtonElement) && e.target) {
            if (window.location.href.indexOf('printarticle') > -1) {
                if (e.target.getAttribute('data-type') === 'regular') {
                    if (isUpgrade) {
                        item_category3 = 'digitalView_upgrade_paywall_blocker_cta';
                    } else {
                        item_category3 = 'digitalView_AS_paywall_blocker_cta_main';
                    }

                } else {
                    if (isUpgrade) {
                        item_category3 = 'digitalView_upgrade_paywall_blocker_cta_secondary';
                    } else {
                        item_category3 = 'digitalView_AS_paywall_blocker_cta_secondary';
                    }
                }
            } else {
                if (e.target.getAttribute('data-type') === 'regular') {
                    if (isUpgrade) {
                        item_category3 = 'digitalView_upgrade_paywall_blocker_cta';
                    } else {
                        item_category3 = 'digitalView_list_paywall_blocker_cta_main';
                    }
                } else {
                    if (isUpgrade) {
                        item_category3 = 'digitalView_upgrade_paywall_blocker_cta_secondary';
                    } else {
                        item_category3 = 'digitalView_list_paywall_blocker_cta_secondary';
                    }
                }
            }
            cta_text = e.target.innerText || ''
        }

        if (isAppView) {

            if (hasNewTilBridge()) {
                const { dealCode, planCode, planCodeAutoSelected, } = newPlanpageMetaData(item);
                let deeplinkValue = '';
                if (isUpgrade) {
                    if (!!(isIOS())) {
                        deeplinkValue = 'toiapp://open-$|$-id=1-$|$-type=planPage-$|$-source=listing-$|$-dealcode=<dealCode>-$|$-featurecode=TOIPRED-$|$-planautoselected=<planAutoSelected>-$|$-plangroup=<planGroup>';
                    } else {
                        deeplinkValue = `toiapp://open-$|$-id=1-$|$-type=upgradePlan-$|$-source=listing-$|$-featurecode=TOIPRED-$|$-ctaType=${item_category3}-$|$-ctaText=${cta_text}`;
                    }
                } else {
                    if (!!isIOS()) {
                        deeplinkValue = 'toiapp://open-$|$-id=1-$|$-type=planPage-$|$-source=listing-$|$-dealcode=<dealCode>-$|$-featurecode=TOIPRED-$|$-planautoselected=<planAutoSelected>-$|$-plangroup=<planGroup>';
                    } else {
                        deeplinkValue = `toiapp://open-$|$-id=1-$|$-type=planPage-$|$-source=listing-$|$-featurecode=TOIPRED-$|$-ctaType=${item_category3}-$|$-ctaText=${cta_text}`;
                    }
                }
                const deeepUrlObj: any = {
                    "type": "deeplink",
                    "value": deeplinkValue,
                    "requestReason": "payment"
                }

                if (!!isIOS()) {
                    deeepUrlObj.ctaType = item_category3;
                    deeepUrlObj.ctaText = cta_text;
                }

                unifiedOpenDeepLinkUrl(deeepUrlObj);
            } else {
                if (!!isIOS()) {
                    setupWebViewJavascriptBridge((bridge: any) => printSubsDeeplink(bridge));
                } else {
                    //For communicating between App JS Interface
                    try {
                        printSubsDeeplink();
                    }
                    catch (e) {
                        console.log('bridge not generated', e);
                    }
                }
            }

        } else {
            if ((e.target instanceof HTMLButtonElement || e.target instanceof HTMLAnchorElement) && e.target) {
                const grxParams = [
                    'paywall', {
                        client_source: 'cdp',
                        event_nature: 'click',
                        event_category: isUpgrade ? 'upgrade' : 'subscription',
                        cta_text: e?.target instanceof HTMLElement ? e.target.innerText : '',
                        unique_subscription_id: Cookie.get('_grx') + '_' + (new Date()).getTime(),
                        paywalling_type: showFreeTrailBlocker ? 'free_trial' : ''
                    }
                ];
                let itemCat3 = '';
                if (blockerPopUp) {
                    itemCat3 = e.target.getAttribute('data-type') === 'regular'
                        ? 'paywall_bottomsheet_blocker_cta_main'
                        : 'paywall_bottomsheet_blocker_cta_secondary';
                } else {
                    itemCat3 = e.target.getAttribute('data-type') === 'regular'
                        ? 'paywall_blocker_cta_main'
                        : 'paywall_blocker_cta_secondary';
                }

                let cdpInfo = {};
                if (typeof (window as any).grx !== 'undefined' && typeof (window as any)?.grx_module?.hitPaywallEventReact === 'function') {
                    (window as any).grx_module.hitPaywallEventReact(isUpgrade ? 'upgrade_blocker' : 'paywall', grxParams[1]);
                    cdpInfo = (window as any).grx_module.getCdpInfo() || {};
                } else if (typeof window !== 'undefined' && (window as any).Times.setGRXDataInLocalStorage) {
                    (window as any).Times.setGRXDataInLocalStorage('GRX_QUEUE_EVENT', {
                        eventName: !isUpgrade ? 'paywall' : 'upgrade_blocker',
                        payload: grxParams[1],
                    });
                }
                const cdpParamsObj = grxParams[1] || {};
                const dataToBepassed = {
                    accessiblefeatures: userPrcData?.accessibleFeatures,
                    msid: msid,
                    source: userPrcData?.source,
                    accessType: userPrcData?.accessType,
                    analytics_cdp: {
                        eventName: !isUpgrade ? 'subscription_feature' : 'upgrade_blocker',
                        ...cdpParamsObj,
                        ...cdpInfo
                    },
                    objUserData: {
                        email: typeof userData.getEmail !== 'undefined' ? userData.getEmail() : '',
                        fname: typeof userData.getFirstName !== 'undefined' ? userData.getFirstName() : ''
                    },
                    ga4Items: fireGA4({
                        action: 'click',
                        item_category4: cta_text,
                        item_category3: `${item_category3}${showFreeTrailBlocker ? '_freeTrial' : ''}`,
                    })
                }
                sendDataToGAWithGRX(dataToBepassed).then(() => redirection({ ...item, acqSubSource: item_category3 }))
            }
        }
    }

    const downLoadNowBtnHandler = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent> | React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
        const grxParams = [
            'paywall', {
                client_source: 'cdp',
                event_nature: 'click',
                event_category: isUpgrade ? 'upgrade' : 'subscription',
                cta_text: e?.target instanceof HTMLElement ? e.target.innerText : '',
                unique_subscription_id: Cookie.get('_grx') + '_' + (new Date()).getTime(),
                paywalling_type: showFreeTrailBlocker ? 'free_trial' : ''
            }
        ];
        let cdpInfo = {};
        if (typeof (window as any).grx !== 'undefined' && typeof (window as any)?.grx_module?.hitPaywallEventReact === 'function') {
            (window as any).grx_module.hitPaywallEventReact(isUpgrade ? 'upgrade_blocker' : 'paywall', grxParams[1]);
            cdpInfo = (window as any).grx_module.getCdpInfo() || {};
        } else {
            (window as any).Times.setGRXDataInLocalStorage('GRX_QUEUE_EVENT', {
                eventName: !isUpgrade ? 'paywall' : 'upgrade_blocker',
                payload: grxParams[1],
            });
        }
        if ((e.target instanceof HTMLAnchorElement || e.target instanceof HTMLButtonElement) && e.target) {
            fireGA4({
                action: 'click',
                item_category3: 'paywall_blocker_cta_main_free_Trial',
                item_category4: e.target.innerText || '',
            });
        }
        if (isAppView) {
            const deeepUrlObj = {
                'requestReason': 'freeTrial',
                'type': 'deeplink',
                'value': "toiapp://open-$|$-id=1-$|$-type=freeTrial"
            }
            unifiedOpenDeepLinkUrl(deeepUrlObj);
        } else {
            const oneLinkUrl = generateOneLinkURL('ARTICLESHOW_FREETRAIL');
            if (oneLinkUrl) {
                window.location.href = oneLinkUrl;
            }
        }
    }


    if ((!nudgeText || transLoading === 'ERROR') && transLoading !== 'LOADING' && !blockerPopUp) {
        if (userData?.isLoggedIn && (!loading || loading === LOADING_STATE.LOADING)) {
            return null;
        }
        shouldShowPopUp(false);
        return <BlockerErrorScreen transLoading={transLoading} onRetryToipTransCallback={onRetryToipTransCallback} />;
    }

    if (isToiPlusAllowReadOnly && !blockerPopUp) {
        shouldShowPopUp(false);
        return <EuBlockerScreen isLoggedIn={isLoggedIn} loginComponent={loginComponent} />
    }

    if (typeof shouldShowPopUp !== 'undefined') {
        shouldShowPopUp(true);
    }


    const { storyBlocker, offers, storyBlockerPopUp } = nudgeText || {};

    const getOfferSection = () => {
        if (offers) {
            return (
                <Bottomcontainer bannerImage={offers.bannerImage}>
                    <Infotext mobile={isWapView}>{offers.h1}</Infotext>
                    <Discounttext mobile={isWapView}>{offers.h2}</Discounttext>
                    <CtaButtonNew onClick={(e: any) => ctaClickHandler(e, nudgeText)} data-type='offer'>{offers.ctaText}</CtaButtonNew>
                </Bottomcontainer>
            )
        }
    }

    if (showFreeTrailBlocker) {
        return (
            <>
                {nudgeText && (
                    <>
                        <Container>
                            <ContainerInner>
                                <Title>{nudgeText.h1}</Title>
                                <SubTitle>{nudgeText.h2}</SubTitle>
                                <ParaTag>{nudgeText.benefit?.h1}</ParaTag>
                                <List>
                                    {
                                        nudgeText.benefit?.benefits?.map((item: string, index: number) => {
                                            return <ListItems key={index} dangerouslySetInnerHTML={{
                                                __html: item,
                                            }} />
                                        })
                                    }
                                </List>
                                <Button>
                                    <a href={NEW_PLANPAGE_URL} onClick={(e) => downLoadNowBtnHandler(e)}>
                                        {nudgeText.mainCtaText}
                                    </a>
                                </Button>
                                <LinkButton >
                                    <a href={NEW_PLANPAGE_URL} className={'viewplan'} onClick={(e) => ctaClickHandler(e, nudgeText)}>
                                        {nudgeText.secCtaText}
                                    </a>
                                </LinkButton>
                            </ContainerInner>
                        </Container>
                        <SignInBtn>
                            {!isLoggedIn ? loginComponent : null}
                        </SignInBtn>
                    </>
                )}
            </>
        );
    }

    if (blockerPopUp && storyBlockerPopUp) {
        return (
            <BlockerPopupContainer>
                <TopContainerPopUP mobile={isWapView}>
                    <ToptextPopUp mobile={isWapView}>{storyBlockerPopUp.h1}</ToptextPopUp>
                    <HeadingPopUp mobile={isWapView}>{storyBlockerPopUp.h2}</HeadingPopUp>
                    <ListItem mobile={isWapView}>
                        <ListInnerwrapper mobile={isWapView}>
                            {storyBlockerPopUp.benefits.map((benefit: any) =>
                                <ListInner mobile={isWapView}>
                                    <IconBox mobile={isWapView}>
                                        <IconImage mobile={isWapView} src={`https://static.toiimg.com/photo/${benefit.icon}.cms`} />
                                    </IconBox>
                                    <IconText>{benefit.text}</IconText>
                                </ListInner>)}
                        </ListInnerwrapper>
                    </ListItem>
                    <CtaButtonPopUp mobile={isWapView} onClick={(e: any) => ctaClickHandler(e, nudgeText)} data-type='regular'>{storyBlockerPopUp.ctaText}</CtaButtonPopUp>
                    {!isLoggedIn ? loginComponent : null}
                </TopContainerPopUP>
                {getOfferSection()}
            </BlockerPopupContainer>
        )
    }

    return (
        <>
            {storyBlocker ? <Blockercontainer>
                <TopContainer mobile={isWapView}>
                    <Toptext mobile={isWapView}>{storyBlocker.h1}</Toptext>
                    <Heading mobile={isWapView}>{storyBlocker.h2}</Heading>
                    <CtaButton onClick={(e: any) => ctaClickHandler(e, nudgeText)} data-type='regular'>{storyBlocker.ctaText}</CtaButton>
                    {!isLoggedIn ? loginComponent : null}
                </TopContainer>
                {getOfferSection()}
            </Blockercontainer> : null}
        </>
    );
};

const Blockercontainer = styled.div`
    background: #FFF0EC;
    padding: 8px 8px 0;
    box-shadow: 0px 12px 24px 0px rgba(0,0,0,0.1);
`;
const BlockerPopupContainer = styled.div`
    background: #FFF0EC;
    padding: 8px 8px 0;
    box-shadow: 0px 12px 24px 0px rgba(0,0,0,0.1);
    max-width: 840px;
    margin: 0 auto;
`;


const TopContainer = styled.div`
    background: #fff;
    padding: 32px;
    display: flex;
    flex-flow: column;
    align-items: center;
    text-align: center;
    ${(props: any) => props.mobile == true && css`
        padding: 16px;
    `}
    @media screen and (max-width: 1366px) and (min-width: 1180px) {
        padding: 16px;
    }
`;

const Toptext = styled.p`
    font-size: 20px;
    line-height: 28px;
    font-weight: 400;
    margin-bottom: 12px;
    ${(props: any) => props.mobile == true && css`
        font-size: 16px;
        line-height: 20px;
    `}
    @media screen and (max-width: 1366px) and (min-width: 1180px) {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 8px;
    }
`;

const Heading = styled.h3`
    font-size: 24px;
    line-height: 32px;
    letter-specing: - 0.5px;
    font-weight: 700;
    margin-bottom: 32px;
    ${(props: any) => props.mobile == true && css`
        font-size: 20px;
        line-height: 28px;
    `}
     @media screen and (max-width: 1366px) and (min-width: 1180px) {
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 16px;
    }
`;
export const CtaButton = styled.button`
    border-radius: 2px;
    background: #E21B22;
    color: #fff;
    font-size: 20px;
    line-height: 24px;
    padding: 8px 24px;
    letter-specing: - 0.5px;
    font-weight: 700;
    margin-bottom: 12px;
`;

const Infotext = styled.p`
    color: #000;
    font-size: 18px;
    line-height: 24px;
    font-weight: 400;
    margin-bottom: 12px;
    ${(props: any) => props.mobile == true && css`
        font-size: 16px;
        line-height: 20px;
    `}
    @media screen and (max-width: 1366px) and (min-width: 1180px){
        font-size: 14px;
        line-height: 24px;
        margin-bottom: 0;
    }
`;

const Bottomcontainer = styled.div`
    background-size: cover;
    padding: 24px;
    display: flex;
    flex-flow: column;
    align-items: center;
    ${(props: any) => css`
        background: url(https://static.toiimg.com/photo/${props.bannerImage}.cms) no-repeat 0 0;
    `}
    @media screen and (max-width: 1366px) and (min-width: 1180px){
        padding: 16px;
    }
`;

const TopContainerPopUP = styled.div`
    background: #fff;
    padding: 24px;
    display: flex;
    flex-flow: column;
    align-items: center;
    text-align: center;
    ${(props: any) => props.mobile == true && css`
        padding: 16px;
        text-align: left;
        align-items: flex-start;
    `}
    @media screen and (max-width: 1366px) and (min-width: 1180px){
        padding: 16px;
    }
`;

const ToptextPopUp = styled.p`
    color: #000;
    font-size: 20px;
    line-height: 24px;
    font-weight: 400;
    margin-bottom: 12px;
    ${(props: any) => props.mobile == true && css`
        font-size: 24px;
        line-height: 32px;
        font-weight: 700;
    `}
    @media screen and (max-width: 1366px) and (min-width: 1180px){
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 0;
    }
`;

const HeadingPopUp = styled.h3`
    color: #000;
    font-size: 24px;
    line-height: 30px;
    font-weight: 700;
    margin-bottom: 24px;
    ${(props: any) => props.mobile == true && css`
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 12px;
    `}
     @media screen and (max-width: 1366px) and (min-width: 1180px){
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 16px;
    }
`;
export const CtaButtonPopUp = styled.button`
    border-radius: 2px;
    background: #E21B22;
    color: #fff;
    font-size: 20px;
    line-height: 24px;
    padding: 8px 24px;
    letter-specing: - 0.5px;
    font-weight: 700;
    margin: 12px 0;
    ${(props: any) => props.mobile == true && css`
        display: none;
    `}
    @media screen and (max-width: 1366px) and (min-width: 1180px){
        font-size: 16px;    
        padding: 5px 24px;
        letter-spacing: -0.5px;
    }
`;

const Discounttext = styled.h3`
    color: #E21B22;
    font-size: 20px;
    line-height: 24px;
    font-weight: 700;
    margin-bottom: 12px;
    max-width: 60%;
    text-align: center;
    ${(props: any) => props.mobile == true && css`
        max-width: 100%;
    `}
    @media screen and (max-width: 1366px) and (min-width: 1180px){
        font-size: 16px;
        line-height: 24px;
    }
`;

const CtaButtonNew = styled.button`
    border-radius: 2px;
    border: 1px solid #E21B22;
    background: #fff ;
    color: #E21B22;
    font-size: 16px;
    line-height: 24px;
    padding: 8px 24px;
    font-weight: 700;
    text-transform: capitalize;
    @media screen and (max-width: 1366px) and (min-width: 1180px){
        font-size: 14px;
    }
`;
const ListItem = styled.div`
    margin: 0px auto;
    display: flex;
    flex-wrap: wrap;
    ${(props: any) => props.mobile === true && css`
        flex-flow: column;
        width: 100%;
    `}
`;
const ListInnerwrapper = styled.div`
    max-width: 700px;
    margin: 0px auto;
    display: flex;
    flex-wrap: wrap;
    ${(props: any) => props.mobile === true && css`
        flex-flow: column;
        width: 100%;
    `}
    @media screen and (max-width: 1366px) and (min-width: 1180px){
       max-width: 640px;
    }
`;

const ListInner = styled.div`
    flex: 0 0 50%;
    flex: 0 0 calc(50% - 16px);
    margin: 8px;
    display: flex;
    align-items: center;
    ${(props: any) => props.mobile === true && css`
        margin: 8px 8px 8px 0;
    `}
   @media screen and (max-width: 1366px) and (min-width: 1180px){
        margin: 8px;
    }
`;

const IconBox = styled.div`
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: #f7f7f7;
    border: 1px solid #D8D8D8;
    display: flex;
    align-items: center;
    justify-content: center; 
    margin-right: 8px;
    ${(props: any) => props.mobile === true && css`
        width: 32px;
        height: 32px;
    `}
    @media screen and (max-width: 1366px) and (min-width: 1180px){
        width: 32px;
        height: 32px;
    }
`;

const IconImage = styled.img`
    ${(props: any) => css`
        background: url(https://static.toiimg.com/photo/${props.imageIcon}.cms) no-repeat 0 0;
    `}
    ${(props: any) => props.mobile === true && css`
        width: 16px;
        height: 16px;
    `}
    @media screen and (max-width: 1366px) and (min-width: 1180px){
        height: 18px;
    }
`;
const IconText = styled.span`
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    @media screen and (max-width: 1366px) and (min-width: 1180px){
        font-size: 12px;
        line-height: 16px;
    }
`;

export default withNudgeLogic(StoryBlocker, 'storyBlockerV3');
